// Libs
import { ModelBase } from "@shoothill/core";
import { Amendment } from "Globals/Models/Amendment";
import { FormSectionsEnum } from "Globals/Models/FormSectionsEnum";
import * as MobX from "mobx";

export class AmendmentModel extends ModelBase<AmendmentModel, Amendment> {
    @MobX.observable public id: string | null = null;
    @MobX.observable public formId: string = "";
    @MobX.observable public applicantId: string = "";
    @MobX.observable public formSection: FormSectionsEnum | null = null;
    @MobX.observable public amendmentNotes: string = "";
    @MobX.observable public createdDate: Date | null = null;
    @MobX.observable public isDeleted: boolean = false;

    // This is used to store the amendment note for if the user presses the canel button
    @MobX.observable private tempAmendmentNotes: string = "";

    @MobX.action
    public fromDto = (model: Amendment): void => {
        if (model !== null && model !== undefined) {
            this.id = model.id;
            this.formId = model.formId;
            this.applicantId = model.applicantId;
            this.formSection = model.formSection;
            this.amendmentNotes = model.amendmentNotes;
            this.createdDate = model.createdDate;
            this.isDeleted = model.isDeleted;

            this.tempAmendmentNotes = model.amendmentNotes;
        }
    };

    @MobX.action
    public toDto = (): Amendment => {
        let model: Amendment = {
            id: this.id,
            formId: this.formId,
            applicantId: this.applicantId,
            formSection: this.formSection,
            amendmentNotes: this.amendmentNotes,
            createdDate: this.createdDate,
            isDeleted: this.isDeleted,
        };
        return model;
    };

    @MobX.action
    public reset = (): void => {
        this.amendmentNotes = this.tempAmendmentNotes;
    };
}
